import { ERROR_TYPE } from "./constants";

// Browsers report offline request failures with engine-specific messages
// (Chromium: "Network Error", WebKit: "Load failed", Firefox: "NetworkError..."),
// so detect the offline state directly rather than string-matching the message.
const isOffline = () =>
  typeof navigator !== "undefined" && navigator.onLine === false;

const getErrorType = ({ message, type }) => {
  switch (true) {
    case SERVER || type === ERROR_TYPE.server:
      return ERROR_TYPE.server;
    case isOffline() || "Network Error" === message:
      return ERROR_TYPE.network;
    default:
      return ERROR_TYPE.generic;
  }
};

export default getErrorType;
